import { Component, OnInit } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';

import { ConfirmationModalComponent } from '@app/components/modals/confirmation-modal/confirmation-modal.component';
import { ApiPtrabUrls, PdfService } from '@app/ptrab/services';
import { ModalManager, NavigationEvent, NavigationEvents, NavigationService } from '@app/services';
import { UserService } from '@app/services/user/user.service';
import { PAGES } from '@app/shared/enums/pages/pages.enum';
import { Permissions } from '@app/shared/enums/permissions/permissions.enum';
import { ILinkCard } from '@app/shared/interfaces/link-card/link-card.interface';
import { Buttons } from '@app/shared/models/buttons/buttons';

import { EXWORKERS_CARDS } from './home-exworkers.const';

@Component({
  selector: 'app-home-exworkers',
  templateUrl: 'home-exworkers.page.html',
  styleUrls: ['home-exworkers.page.scss']
})
export class HomeExworkersPage implements OnInit {
  exworkersCards!: ILinkCard[];
  username!: string;
  permissions: Permissions[] = [];

  constructor(
    private modalManager: ModalManager,
    private navigationService: NavigationService,
    private userService: UserService,
    private pdfService: PdfService,
    private apiUrls: ApiPtrabUrls
  ) {}

  async ngOnInit() {
    const user = await this.userService.getStoredUser();
    this.username = user.name + ' ' + user.lastname;
    this.permissions = user.permissions;
    this.showCardsByPermissions();
  }

  logout() {
    const title = 'ON_BOARDING.LOGOUT_TITLE';
    const contents = ['ON_BOARDING.LOGOUT_DESCRIPTION'];
    const buttons: Buttons[] = [
      {
        text: 'NO',
        type: 'secondary',
        enabled: true,
        onClick: () => {
          this.modalManager.dismissMatModal();
        }
      },
      {
        text: 'YES',
        type: 'primary',
        enabled: true,
        onClick: () => {
          this.modalManager.dismissMatModal();
          const navEvent = new NavigationEvent(NavigationEvents.SetRoot, { path: PAGES.LOGOUT });
          this.navigationService.navigate(navEvent);
        }
      }
    ];
    const modalOpts: MatDialogConfig = {
      data: { title, contents, buttons },
      disableClose: true,
      panelClass: ['media-content-modal', 'confirmation-two-lines-modal']
    };

    this.modalManager.openMatModal(ConfirmationModalComponent, modalOpts);
  }

  onCardClick(card: ILinkCard) {
    if (card.link) {
      const navEvent = new NavigationEvent(NavigationEvents.Push, { path: card.link });
      this.navigationService.navigate(navEvent);
    } else {
      const certificateUrl = this.apiUrls.exemployee.contributions;
      const errorMsg = 'EMPLOYEE_PORTAL.WITHHOLDING_CERTIFICATE_ERROR_DESC';

      this.pdfService.fetch(certificateUrl, errorMsg);
    }
  }

  private showCardsByPermissions() {
    this.exworkersCards = EXWORKERS_CARDS.filter((element) =>
      element.permissions?.some((permission) => this.permissions.includes(permission))
    );
  }

  trackByItems(item: ILinkCard) {
    return item;
  }
}
